import {useEffect, useRef} from 'react';

import {recordRumDurationVital} from '../../../util/datadog/datadogRum';
import {type AlignmentMeasurement} from './getAlignedData';

/** Each chart observes committed sizes once; rendering layers share its data. */
export function useAlignmentProfile(
  panelId: string,
  measurement: AlignmentMeasurement | undefined
) {
  const profileRef = useRef({panelId, lastAlignedYSlotCount: 0});
  useEffect(() => {
    if (profileRef.current.panelId !== panelId) {
      profileRef.current = {panelId, lastAlignedYSlotCount: 0};
    }
    if (measurement == null) {
      return;
    }
    const {alignedYSlotCount, sample} = measurement;
    const sizeChanged =
      alignedYSlotCount !== profileRef.current.lastAlignedYSlotCount;
    // Observe unsampled changes too, so equal sizes cannot retry sampling.
    profileRef.current.lastAlignedYSlotCount = alignedYSlotCount;
    if (sizeChanged && sample != null && sample.duration > 0) {
      recordRumDurationVital('workspace.func_perf.getAlignedData', {
        startTime: sample.startTime,
        duration: sample.duration,
        description: 'synchronous getAlignedData function duration',
        context: {...sample.context, panelId},
      });
    }
  }, [panelId, measurement]);
}
